import { Component, Input } from '@angular/core';
import { MeasurementToolModel } from '@evorait/pace-core';

@Component({
    selector: 'pace-confirmation-summary-measurement-tools',
    templateUrl: './confirmation-summary-measurement-tools.component.html',
    styleUrls: ['./confirmation-summary-measurement-tools.component.scss'],
    standalone: false,
})
export class ConfirmationSummaryMeasurementToolsComponent {
    @Input()
    public displayMeasurementTool = false;

    @Input()
    public measurementTools: MeasurementToolModel[];

    @Input()
    public measurementToolsDetailsList: MeasurementToolModel[];

    @Input()
    public displayMeasurementToolDetails = false;

    @Input()
    public measurementToolsEmptyMessage?: string;

    @Input()
    public radioActiveToolMessage: string;
}
